/**
 * Cold-load placeholder for a single capability row. Matches the
 * ``CapabilityRow`` height + padding + badge-square layout so the page
 * does not shift when real rows arrive.
 */
export const IntegrationRowSkeleton: React.FC = () => (
  <li
    className="flex items-center gap-3 rounded-lg border border-hairline bg-card/40 px-3 py-2.5"
    aria-hidden
  >
    <div className="h-9 w-9 shrink-0 animate-pulse rounded-md bg-ink-3/15" />
    <div className="flex min-w-0 flex-1 flex-col gap-1.5">
      <div className="h-3 w-32 animate-pulse rounded bg-ink-3/15" />
      <div className="h-2.5 w-48 animate-pulse rounded bg-ink-3/10" />
    </div>
  </li>
);
IntegrationRowSkeleton.displayName = "IntegrationRowSkeleton";
